import React, { PropsWithChildren } from "react";
import * as styles from "./MenuSection.module.scss";
import clsx from "clsx";

type MenuSectionItemProps = {
  className?: string;
  role?: React.AriaRole;
  variant?: "mega" | "legacy";
};
const MenuSectionItem: React.FC<PropsWithChildren<MenuSectionItemProps>> = ({
  className,
  children,
  role = "none",
  variant = "mega"
}) => {
  return (
    <li
      className={clsx(
        styles.primarySection,
        { [styles.variantLegacy]: variant == "legacy" },
        className
      )}
      role={role}
    >
      {children}
    </li>
  );
};

export default MenuSectionItem;
